import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class PlotYes extends Component
{

    back(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    backplot(){
        this.props.store.plotyes = "nothing";
        this.forceUpdate();
    }

    plotyes2(){
        this.props.store.plotyes = "plotyes2";
        this.forceUpdate();
    }

    plotyes3(){
        this.props.store.plotyes = "plotyes3";
        this.forceUpdate();
    }




    common(){
        this.props.store.plotyes = "common";
        this.forceUpdate();
    }

    commonfear(){
        this.props.store.plotyes = "commonfear";
        this.forceUpdate();
    }

    commonanger(){
        this.props.store.plotyes = "commonanger";
        this.forceUpdate();
    }

    commonlaught(){
        this.props.store.plotyes = "commonlaught";
        this.forceUpdate();
    }

    commoncry() {
        this.props.store.plotyes = "commoncry";
        this.forceUpdate();
    }

    commonhook(){
        this.props.store.plotyes = "commonhook";
        this.forceUpdate();
    }

    man(){
        this.props.store.plotyes = "man";
        this.forceUpdate();
    }

    manshow(){
        this.props.store.plotyes = "manshow";
        this.forceUpdate();
    }

    manface(){
        this.props.store.plotyes = "manface";
        this.forceUpdate();
    }

    mansave() {
        this.props.store.plotyes = "mansave";
        this.forceUpdate();
    }

    manbeauty(){
        this.props.store.plotyes = "manbeauty";
        this.forceUpdate();
    }

    manpig(){
        this.props.store.plotyes = "manpig";
        this.forceUpdate();
    }

    girl() {
        this.props.store.plotyes = "girl";
        this.forceUpdate();
    }

    girlsacrifice(){
        this.props.store.plotyes = "girlsacrifice";
        this.forceUpdate();
    }

    girlconfess() {
        this.props.store.plotyes = "girlconfess";
        this.forceUpdate();
    }

    girldifferent() {
        this.props.store.plotyes = "girldifferent";
        this.forceUpdate();
    }

    girllost() {
        this.props.store.plotyes = "girllost";
        this.forceUpdate();
    }

    girldanger(){
        this.props.store.plotyes = "girldanger";
        this.forceUpdate();
    }

    
    render()
    {
        return <>
        
        {this.props.store.plotyes == "nothing" &&  <div className = "asktext">
        欢迎来到情节指南~<br/><br/>
        情节练习对小说写作来说，是重中之重<br/>
        了解每个情节片段对整个故事的作用，以及情节片段如何搭配，将会让写小说的能力发生天翻地覆的改变<br/><br/>

        相信你已经迫不及待了对不对<br/>
        想了解通用的情节设置，请点击通用按钮<br/>
        对于专注男频或专注女频的写手，也设置了爽文套路和言情套路<br/>
        请选择自己想要了解的情节安排，然后开始吧~
        
        
        
       <br/>
       <div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >通用情节</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >爽文套路</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >言情套路</Button><br/><br/><br/>

        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.plotyes2() } >我已经都写好啦！</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >不，我要练文笔或结构</Button><br/>
    </div>   
    </div> }

    {this.props.store.plotyes == "plotyes2" &&  <div className = "asktext">
        写完了吗，真了不起！<br/><br/>
        不过只看讲解和练习是不够的哦<br/>
        套路篇也需要摘抄和仿写<br/><br/>
        请找出一个本子来，分门别类的写上套路名称<br/>
        并且从看的小说中找到相关套路，并摘抄下来<br/>
        摘抄时记得标注好书名和章节名，方便查找<br/><br/>
        摘抄完一天之后，可以仿写这个片段，并与原文进行对比分析<br/><br/>
        如果想要练习情节与套路，请一周保持2~3篇的摘抄和仿写量<br/><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.plotyes3() } >好的！</Button><br/>
        </div>}

        {this.props.store.plotyes == "plotyes3" &&  <div className = "asktext">
            恭喜你！已经完成了情节指南啦~<br/><br/>
            不过情节的练习道路，可不会那么简单就结束<br/>
            如果这里的情节已经很熟练了，可以去公众号“过雨红素”查看更多的套路讲解<br/><br/>
            当然更重要的是，学会自己分析情节的作用，并归纳成套路<br/>
            今后在看小说，看电影，看电视剧的时候<br/>
            遇到好的情节，可以记下来<br/>
            想想看是什么打动了你，如果自己写要怎么写出这样的效果<br/>
            积累自己的情节素材库，对写小说是很重要的！<br/><br/>
            好啦~情节指南到此为止。<br/>
            对其他部分的内容感兴趣的话，可以查看文笔和结构篇<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >我要练文笔或结构</Button><br/>

            </div>}

    {this.props.store.plotyes == "common" &&  <div className = "asktext">
        欢迎来到通用情节指南<br/><br/>
        通用情节是指，在大部分小说里都可以使用的情节设置<br/>
        请点击相应的按钮，查看相关的讲解<br/>
        <br/>
        <div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.commonfear() } >恐怖</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.commonanger() } >愤怒</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.commonlaught() } >笑点</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.commoncry() } >泪点</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.commonhook() } >悬疑</Button><br/>



        </div>
        
       
<br/>

<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backplot() } >返回</Button><br/>
        </div>}

        {this.props.store.plotyes == "commonfear" &&  <div className = "asktext">
            欢迎来到恐惧的情节讲解<br/>
            <br/>
            在恐怖小说中，这是最重要的情绪<br/>
            但对于普通小说，偶尔增加恐怖要素，也是不错的选择<br/>
            <br/>
            恐惧，是人受到伤害或威胁时产生的一种情绪<br/>
            但不是所有伤害和威胁都会引起恐惧。<br/><br/>
            心理学上有一个理论，叫“战斗或逃跑反应”。意思是一个人在受到攻击，感受到威胁的时候，会有两种反应，第一种是战斗，对应的情感是愤怒。第二种是逃跑，对应的情感是恐惧。<br/><br/>
            当受到威胁，一个人可能愤怒也可能害怕。为了让人感到害怕，需要告诉他，这个东西是你应付不来的。没法战斗，就只剩下逃跑了。<br/>
            <br/>
            所以恐惧的重点，就是制造人物“应付不了”或“无能为力”<br/><br/>
            通过描述敌人的强大，恶意与残忍，诡异与未知，可以做到这一点<br/>
            最常见的是通过同伴的死亡，来表现敌人的强大，残忍或诡异<br/><br/>
            如果对恐怖的情节有兴趣，请写这样一个情节<br/>
            当主角去找朋友叙旧时，发现TA非常怪异的死在了屋内<br/>
            这种死法不是正常人做到的，而且主角再也无法离开屋子<br/>
            请参照技巧，努力营造恐怖氛围<br/><br/>
            写完之后可以试试其他的情节指南哦<br/>
<Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >返回通用情节</Button><br/>
            </div>}

            {this.props.store.plotyes == "commonanger" &&  <div className = "asktext">
            欢迎来到愤怒的情节讲解<br/>
            <br/>
            愤怒几乎是最有破坏力的情绪，容易让人失去理智，导向极端行动<br/>
            因为它能引发行动，所以在小说中，情节出发的愤怒，会让读者愤愤不平，想看主角打脸，给敌人一个教训。这种情绪会催促着读者不断的读下去。<br/>
            这是爽文中常用的手法<br/><br/>
            在恐惧的讲解中，讲了受攻击后的战或逃反应<br/>
            为了引起愤怒，避免引起恐惧，需要这个伤害不那么强大，残忍和诡异<br/>
            并且渲染这个伤害不应当发生，敌人对主角的挑衅和不断积攒的怨气<br/><br/>
            如果对愤怒有兴趣，可以试着写这样一个情节<br/>
            主角对某个配角有恩，在落难后去找他帮忙<br/>
            但他不仅不帮忙，还落井下石，并且嘲笑主角<br/>
            咄咄逼人，不断得寸进尺，想从主角身上拿走更多<br/>
            （注意写出这个越来越过分的过程）<br/>
            请参照技巧，努力让人愤怒起来<br/><br/>
            写完之后可以试试其他的情节指南哦<br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >返回通用情节</Button><br/>
            <br/>
                </div>}


                {this.props.store.plotyes == "commonlaught" &&  <div className = "asktext">
            欢迎来到笑点的情节讲解<br/>
            愉快欢乐的故事，总是讨人喜欢的<br/><br/>
            如何让读者笑，需要把握笑点的核心：意外<br/>
            意料之外的事才会让人发笑，中规中矩，符合场景，切合逻辑的情节，是不会出现笑点的<br/><br/>
            所以笑点分两部分，铺垫和意外。<br/>
            需要先预设一个情景，然后打破这个情景。<br/><br/>
            这并不是很难<br/>
            因为在生活中，所有人都不断在做假设<br/>
            你所需要的就是发现假设，然后打破它<br/>
            比如在看到“今天早上我起床跑了5公里。”这句话的时候，大家就会有以下的几种假设。<br/>
            a：他跑步是为了锻炼<br/>
            b：“我跑”意味着他亲自跑的。<br/>
            c：他没有撒谎。<br/><br/>
            根据这些假设，就可以写出相关的意外来颠覆他们，写出不同的笑话。<br/>
            比如他跑步是因为他被一张脸吓到了，或者他撒谎，或者他其实是请别人帮自己跑的等等。
            <br/><br/>
            当然不是所有意外都好笑<br/>
            这是需要经验和摸索的。<br/>
            技巧是不要让大家对意外困惑<br/>
            以及不要让大家察觉到伤害和痛苦<br/>
            如果猫和老鼠中，汤姆猫被拍扁之后变成一团肉泥<br/>
            那大家就笑不出来了<br/>
            感兴趣的话，可以试着在自己的故事里加入笑点<br/>
            写完之后可以试试其他的情节指南哦<br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >返回通用情节</Button><br/>
            </div>}


            
            {this.props.store.plotyes == "commoncry" &&  <div className = "asktext">
            欢迎来到泪点的情节讲解<br/>
            关于如何让读者哭的理论，目前非常不成熟。<br/>
            因为流泪并不是一种情绪，而是很多种情绪都能让人哭<br/>
            悲伤是最常见的，但太开心了也会喜极而泣，太生气了也有人被气哭<br/>
            因为每个人的泪点不太一样，有些人哭得稀里哗啦，其他人可能毫无反应<br/>
            所以只能提供我的泪点<br/><br/>
            分别是委屈，已经没有希望了还勉强挽回以及历史的沧桑<br/>
            可以试着看看自己为什么而哭，并且写出能感动自己的情节吧<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >返回通用情节</Button><br/>

            </div>}

            {this.props.store.plotyes == "commonhook" &&  <div className = "asktext">
            欢迎来到悬疑的情节讲解<br/>
            这是很多地方都提到，非常重要的情节设置<br/><br/>
            悬疑分为悬和疑两部分，先来讲疑<br/>
            疑是指疑问，指能带来疑问，引发读者好奇的情节<br/>
            当一件事超出理解，违背所知规律时，人们就会产生疑问<br/>
            小孩子对什么事都好奇，因为他并没有对世界的知识。逐渐长大时，我们会积累对世界的知识，并对许多事习以为常<br/>
            只有发生超出知识范围，超出理解的事，才会引发疑问和好奇<br/>
            比如密室杀人案，盗墓，鬼故事中的奇异现象<br/>
            或者故事中本来的规律和设定，忽然被颠覆的时候<br/>
            一对恩爱夫妻忽然反目成仇，原先的死敌忽然携手合作<br/>
            这些都会引发好奇。<br/><br/>

            接下来是悬疑的悬<br/>
            当你打算做一件事，但是被打岔不能做，心里一直对它念念不忘。<br/>
            这就是“悬”。一件未解决的事，会悬在你心中<br/>
            人们有对完整，对完成的渴望<br/>
            因此一件事只发生了一半，处于未解决，未完成的状态时，会非常令人揪心和急切<br/>
            重点就是：这件事发生了，有开头，但未完成<br/>
            这件事就被悬挂了起来，称为“悬”<br/>
            被悬起来的可以是任何事情，好事和坏事都行<br/>
            比如主角要和喜欢的人约会，但是在三天后<br/>
            有人来求主角帮忙，刚好主角出门了<br/>
            师傅要教主角绝世武功，但是要主角先做完某事<br/>
            这些都是悬。悬起来的事件越重要，效果越强<br/>
            而如果悬起来的是一个待解决的疑问，效果是最强的<br/>
            因此悬和疑经常在一起，被称为“悬疑”<br/><br/>
            如果对悬疑有兴趣，请写这样一个情节<br/><br/>

            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.common() } >返回通用情节</Button><br/>




                </div>}

                {this.props.store.plotyes == "man" &&  <div className = "asktext">
                欢迎来到爽文套路指南<br/><br/>
                爽文，几乎是男频的代言词，核心是男性思维<br/>
                爽文中最重要的价值，是人物的实力，只要实力比别人强，就能压人一头，把别人踩在脚下，为所欲为，贯彻自己心中的正义<br/>
                这是个强者为王的世界，充斥着竞争，复仇，决斗等元素。<br/>
                并且主角一定会越来越厉害，让所有人都刮目相看。<br/><br/>
                
                这就是爽文，它并不复杂<br/>
                但是可以给人带来成就感，给平庸的人激励，给挫败的人安慰<br/>
                虽然只是虚幻的成功，但谁说精神的满足就不重要了呢<br/><br/>
                下面，就是常见的五种爽文套路<br/>
                更多版本的二十种爽文套路详细讲解，请关注公众号过雨红素<br/>
                  <br/>
                  <div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.manshow() } >显摆</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.manface() } >打脸</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.mansave() } >绝处逢生</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.manbeauty() } >英雄救美</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.manpig() } >扮猪吃虎</Button><br/>
        



        </div>
        <br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backplot() } >返回</Button><br/>
                  
                    </div>}

            
                    {this.props.store.plotyes == "manshow" &&  <div className = "asktext">
                        欢迎来到显摆套路<br/>
                        显摆，顾名思义，就是显露出主角的实力<br/>
                        不管主角的实力有多强，如果没有显露出来，没有让周围人叹服，吃惊，也会不会有爽点<br/>
                        这个简单的套路只有两个组成部分<br/>
                        主角展现实力+他人的反应<br/>
                        就可以组成一个带来爽点的爽文套路啦<br/>
                        常见的反应有惊讶，害怕，钦佩，担忧，欣赏等等<br/><br/>
                        有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >返回爽文套路</Button><br/>

                        </div>}


                        {this.props.store.plotyes == "manface" &&  <div className = "asktext">
                        欢迎来到打脸套路<br/>
                        打脸是指“某人信誓旦旦的断定事态发展后，出现差距极大的结果”。这就像是一记耳光重重的打在脸上，因此被称为打脸<br/>
                        <br/>
                        所以打脸有两个组成部分<br/>
                        信誓旦旦的断言，以及差距极大的结果<br/>
                        一般是某人看不起主角，信誓旦旦的说主角一定会输，最后主角赢得很漂亮<br/>
                        断言越信誓旦旦，结果差距越大，证据越有说服力，打脸效果越强<br/>
                        最好当着众人的面，打脸的影响就更加深远<br/><br/>
                        有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >返回爽文套路</Button><br/>

                            
                            </div>}

                            {this.props.store.plotyes == "mansave" &&  <div className = "asktext">
                            欢迎来到绝处逢生套路<br/>
                            绝处逢生是指，主角面临绝境之后，忽然有了奇遇<br/>
                            不仅活了下来，甚至可能获得宝物，武功大涨<br/><br/>
                            绝处逢生有两个组成部分<br/>
                            一个绝境，可能是悬崖，大火，或者敌国入侵都行<br/>
                            一个机遇，给主角带来了生存的希望，以及更多的能力，可能是武功秘籍，绝世法宝甚至是个仙人都行<br/>
                            有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >返回爽文套路</Button><br/>

                                </div>}

                                {this.props.store.plotyes == "manbeauty" &&  <div className = "asktext">
                                欢迎来到英雄救美套路<br/>
                                英雄救美是很经典，很常见，大家都懂的套路<br/><br/>
                                英雄救美有三个组成部分<br/>
                                英雄，一般是主角，要有实力，出类拔萃才能救人<br/>
                                救，要有危急关头，而不是琐事，不然就变成英雄帮美，不是救美了<br/>
                                美，一般是个漂亮的女人，或者至少有独特的优点。对主角有好处，英雄救丑就没意思了<br/><br/>
                                有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >返回爽文套路</Button><br/>




                                    </div>}
                                    {this.props.store.plotyes == "manpig" &&  <div className = "asktext">
                                    欢迎来到扮猪吃虎套路<br/>
                                    这是在爽文中很常见的套路<br/><br/>
                                    扮猪吃虎有三个组成部分<br/>
                                    首先，主角要有过人的实力，并不是真的猪<br/>
                                    其次，他因为合理的原因扮成了猪。需要有合理的原因和扮猪的过程<br/>
                                    最后，他吃了老虎，也就是展现自己真正的势力，并且得到很大的好处<br/><br/>
                                    有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.man() } >返回爽文套路</Button><br/>

                                        </div>}
                
                {this.props.store.plotyes == "girl" &&  <div className = "asktext">
                欢迎来到言情套路指南<br/><br/>
                言情，是指以感情为中心的文类，受众一般是女性<br/>
                并不仅仅包括男女恋情，同性恋，兄弟情等都包含在内。<br/>
                <br/>
                言情文中最重要的价值是大家对你的感情<br/>
                比起实实在在的成就，言情更注重的是社交属性<br/>
                如果主角考试失败了，喜欢的人来安慰自己，这就是个正面的事件<br/><br/>
                言情给大家带来的更多是安全感，价值感和陪伴<br/>
                对于寂寞，孤独，却渴望美好关系的人来说，是平复忧伤的良药<br/>
                对于不愿意发展，或没机会发展真实关系的人来说，言情小说算是某种替代品<br/><br/>
                下面，就是常见的五种言情套路<br/>
                更多版本的二十种言情套路详细讲解，请关注公众号过雨红素<br/><br/>
                <div className = "buttonbox">
                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girlsacrifice() } >牺牲</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girlconfess() } >告白</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girldifferent() } >与众不同</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girllost() } >失而复得</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girldanger() } >共度危机</Button><br/>
                </div><br/>
                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.backplot() } >返回</Button><br/>
                </div>
                }

                


                {this.props.store.plotyes == "girlsacrifice" &&  <div className = "asktext">
                欢迎来到牺牲套路<br/>
                牺牲是指，主角愿意为另一个主角而舍弃重要的事物<br/><br/>
                牺牲有两个组成部分<br/>
                一个重要的事物<br/>
                在合理的情形下，主角愿意为了另一个主角而牺牲它<br/><br/>
                通过牺牲的套路，能体现出主角间关系的重要性<br/>
                就像恋爱中，有些人喜欢问我重要还是游戏重要，我和你妈掉进水里你会救谁一样<br/>
                有些时候，通过牺牲，才能证明关系的价值。

                有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >返回言情套路</Button><br/>
                    </div>}

                    {this.props.store.plotyes == "girlconfess" &&  <div className = "asktext">
                    欢迎来到告白套路<br/>
                    告白指说明和表白，指一个人物向另一个人物吐露心声<br/>
                    不管是现实还是小说中，人物的真实内心都是很少直接表露的<br/>
                    但在某些特定的场合，人物会直接表露内心，称为告白<br/>
                    <br/>
                    告白有两个组成部分<br/>
                    一个被隐藏的心声<br/>
                    一个不得不吐露心声的场合<br/>
                    <br/>
                    这个套路通常用于解除误会或者确定关系<br/>
                    如果主角是不善于表露内心的类型，可以借旁人的口来告白<br/>
                    很多言情小说中，都会有一个主角的朋友，帮忙数落另一个主角“他对你怎么怎么好，你怎么就看不清他的心意balabla”<br/>
                    这也属于告白套路的变体<br/>

                    有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >返回言情套路</Button><br/>
          
                        </div>}

                        {this.props.store.plotyes == "girldifferent" &&  <div className = "asktext">
                        欢迎来到与众不同套路<br/>
                        与众不同，全称对你与众不同，是指主角对另一个主角的态度，行为与众不同<br/>
                        <br/>
                        与众不同有两个组成部分<br/>
                        一个对大家的态度，对众人的状态<br/>
                        一个对你的态度，和对大家不同的态度<br/>
                        <br/>
                        也就是俗称的“双标”<br/>
                        对你和对其他人不同，证明两人的关系不一般，是增加关系价值的套路<br/><br/>
                        与众不同也有两个面向<br/>
                        一个是他对别人都怎么怎么样，但是对你就不这样<br/>
                        比如对其他人很冷漠，但是对你很热情<br/><br/>
                        另一个人别人对你都怎么怎么样，但是他对你就不这样<br/>
                        比如你惹了麻烦，别人都避之不及，只有他愿意收留你<br/><br/>
                        当然这两个面向可以同时发生，很微妙的，大家体会一下<br/>
                        当然有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >返回言情套路</Button><br/>
          
                            </div>}

                            {this.props.store.plotyes == "girllost" &&  <div className = "asktext">
                            欢迎来到失而复得套路<br/>
                            俗话说得好，当有一份爱情摆在我面前，我却不知道珍惜，直到失去了才追悔莫及……<br/>
                            好吧不是俗话，但人就是这样。失去的时候才更能体会到它的重要性<br/>
                            因此，失而复得也是言情中常见的桥段，用来证明这段关系的重要性<br/>
                            <br/>
                            失而复得有两个组成部分<br/>
                            失去的痛苦<br/>
                            和重新获得的喜悦<br/>
                            <br/>
                            非常简单，但有用
                            有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >返回言情套路</Button><br/>
          
                                </div>}

                                {this.props.store.plotyes == "girldanger" &&  <div className = "asktext">
                                欢迎来到共度危难套路<br/>
                                或许你有听过吊桥效应吧，两人一起经历心跳加速的事，就会对对方产生更多的好感<br/>
                                就算无视这个效应，危难中两人互相帮助，相互依赖，也会增加信任，让关系更加紧密<br/>
                                <br/>
                                共度危难有两个组成部分<br/>
                                一个危难<br/>
                                两个主角共同度过它的过程<br/>
                                有兴趣可以试着写一下这样的情节。<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.girl() } >返回言情套路</Button><br/>
          

                                    </div>}

   
        </>;
    }
} 